<!-- Независимый список дополнительных титулов без семантики последовательной шкалы. -->
<template>
  <section
    v-if="items.length"
    class="edo-additional-titles"
    :class="{ 'edo-additional-titles--expanded': expanded }"
  >
    <button
      type="button"
      class="edo-additional-titles__header"
      :aria-expanded="open"
      @click="toggle"
    >
      <span class="edo-additional-titles__heading">
        <span class="edo-additional-titles__eyebrow">Документооборот</span>
        <strong>Дополнительные титулы</strong>
        <span class="edo-additional-titles__description">
          Независимые изменения ЭТрН, которые не образуют обязательную цепочку.
        </span>
      </span>
      <AppIcon
        name="chevronUp"
        :size="16"
        class="edo-additional-titles__toggle-icon"
        :class="{ 'edo-additional-titles__toggle-icon--closed': !open }"
      />
    </button>

    <div v-show="open" class="edo-additional-titles__grid">
      <EdoDocumentAdditionalTitleCard
        v-for="item in items"
        :key="item.key"
        :item="item"
        :selected="item.key === activeTitleKey"
        @select="$emit('select-title', item)"
      />
    </div>

    <div
      v-if="open && expanded"
      class="edo-additional-titles__caret-grid"
      aria-hidden="true"
    >
      <span
        v-for="item in items"
        :key="item.key"
        class="edo-additional-titles__caret-cell"
      >
        <span
          v-if="item.key === activeTitleKey"
          class="edo-additional-titles__caret"
        ></span>
      </span>
    </div>
  </section>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import EdoDocumentAdditionalTitleCard from "@/components/Edo/shared/EdoDocumentAdditionalTitleCard.vue";

export default {
  name: "EdoDocumentAdditionalTitles",

  components: {
    AppIcon,
    EdoDocumentAdditionalTitleCard,
  },

  emits: ["select-title", "update:open"],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activeTitleKey: {
      type: String,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toggle() {
      this.$emit("update:open", !this.open);
    },
  },
};
</script>

<style scoped>
.edo-additional-titles {
  position: relative;
  display: grid;
  gap: 16px;
  padding: 18px;
  border: 1px solid #e3e6ee;
  border-radius: 14px;
  background: #fff;
}

.edo-additional-titles--expanded {
  border-radius: 16px 16px 0 0;
}

.edo-additional-titles__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.edo-additional-titles__heading {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.edo-additional-titles__eyebrow,
.edo-additional-titles__description {
  color: #5b6070;
  font-size: 13px;
  line-height: 18px;
}

.edo-additional-titles__heading strong {
  color: var(--color-dark);
  font-size: 17px;
  line-height: 22px;
}

.edo-additional-titles__toggle-icon {
  flex: none;
  color: #5b6070;
  transition: transform 0.2s ease;
}

.edo-additional-titles__toggle-icon--closed {
  transform: rotate(180deg);
}

.edo-additional-titles__header:focus-visible {
  border-radius: 8px;
  outline: 2px solid var(--color-blue);
  outline-offset: 4px;
}

.edo-additional-titles__grid,
.edo-additional-titles__caret-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.edo-additional-titles__caret-grid {
  position: absolute;
  right: 18px;
  bottom: -8px;
  left: 18px;
  z-index: 2;
}

.edo-additional-titles__caret-cell {
  display: flex;
  justify-content: center;
}

.edo-additional-titles__caret {
  width: 14px;
  height: 14px;
  border-top: 1px solid #e3e6ee;
  border-left: 1px solid #e3e6ee;
  background: #fff;
  transform: rotate(45deg);
}

@media (max-width: 720px) {
  .edo-additional-titles__grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .edo-additional-titles__caret-grid {
    display: none;
  }
}
</style>
